'use client';

import { useTheme } from 'next-themes';
import { VelocityTheme } from '../environmentVariables/EnvironmentVariables';

const useVelocityTheme = () => {
	const themeSetting = useTheme().theme as VelocityTheme;

	return themeSetting;
};

export default useVelocityTheme;
